import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/views/Main.vue'
import Login from '@/views/Login.vue'
import NotFound from '@/views/NotFound.vue'
import Store from '@/store/index'

import { getToken, removeToken, getRoleType } from '@/utils/utils'

Vue.use(Router)

export const manage = {
  path: 'manage',
  name: 'manage',
  component: () => import(/* webpackChunkName: "manage" */ '@/views/Manage/Manage.vue'),
  redirect: {
    name: 'distributorMgmt',
  },
  meta: {
    routerName: 'manage',
  },
  children: [
    {
      path: 'distributorMgmt',
      name: 'distributorMgmt',
      component: () =>
        import(
          /* webpackChunkName: "manage" */ '@/views/Manage/DistributorMgmt/DistributorMgmt.vue'
        ),
      meta: {
        routerName: 'distributorMgmt',
        noChild: true,
        rootPage: true,
        menu: true,
      },
      children: [
        {
          path: 'view/:distributorId',
          name: 'viewDistributor',
          component: () =>
            import(
              /* webpackChunkName: "manage" */ '@/views/Manage/DistributorMgmt/ViewDistributor.vue'
            ),
          meta: {
            routerName: 'viewDistributor',
          },
        },
        {
          path: 'add',
          name: 'addDistributor',
          component: () =>
            import(
              /* webpackChunkName: "manage" */ '@/views/Manage/DistributorMgmt/AddDistributor.vue'
            ),
          meta: {
            routerName: 'addDistributor',
          },
        },
        {
          path: 'edit/:distributorId',
          name: 'editDistributor',
          component: () =>
            import(
              /* webpackChunkName: "manage" */ '@/views/Manage/DistributorMgmt/EditDistributor.vue'
            ),
          meta: {
            routerName: 'editDistributor',
          },
        },
      ],
    },
    {
      path: 'schoolMgmt',
      name: 'schoolMgmt',
      component: () =>
        import(/* webpackChunkName: "manage" */ '@/views/Manage/SchoolMgmt/SchoolMgmt.vue'),
      meta: {
        routerName: 'schoolMgmt',
        noChild: true,
        rootPage: true,
        menu: true,
      },
      children: [
        {
          path: 'view/:schoolId',
          name: 'viewSchool',
          component: () =>
            import(/* webpackChunkName: "manage" */ '@/views/Manage/SchoolMgmt/ViewSchool.vue'),
          meta: {
            routerName: 'viewSchool',
          },
        },
      ],
    },
  ],
}

export const staffMgmt = {
  path: 'staffMgmt',
  name: 'staffMgmt',
  component: () => import(/* webpackChunkName: "staffMgmt" */ '@/views/StaffMgmt/StaffMgmt.vue'),
  meta: {
    routerName: 'staffMgmt',
    noChild: true,
    rootPage: true,
    menu: true,
  },
}

export const resource = {
  path: 'resource',
  name: 'resource',
  component: () => import(/* webpackChunkName: "resource" */ '@/views/Resource/Resource.vue'),
  redirect: {
    name: 'mibp',
  },
  meta: {
    routerName: 'resource',
  },
  children: [
    {
      path: 'mibp',
      name: 'mibp',
      component: () => import(/* webpackChunkName: "resource" */ '@/views/Resource/MIBP/MIBP.vue'),
      meta: {
        routerName: 'mibp',
        rootPage: true,
        noChild: true,
        menu: true,
      },
      children: [
        {
          path: 'detail/:bundleId',
          name: 'mibpDetail',
          component: () =>
            import(/* webpackChunkName: "resource" */ '@/views/Resource/MIBP/MIBPDetail.vue'),
          meta: {
            routerName: 'mibpDetail',
            showBack: true,
          },
        },
        {
          path: 'subscribe/:bundleId',
          name: 'mibpSubscribe',
          component: () =>
            import(/* webpackChunkName: "resource" */ '@/views/Resource/MIBP/MIBPSubscribe.vue'),
          meta: {
            routerName: 'mibpSubscribe',
            showBack: true,
          },
        },
      ],
    },
    {
      path: 'phdCourse',
      name: 'phdCourse',
      component: () =>
        import(/* webpackChunkName: "resource" */ '@/views/Resource/PHDCourse/PHDCourse.vue'),
      meta: {
        routerName: 'phdCourse',
        rootPage: true,
        noChild: true,
        menu: true,
      },
      children: [
        {
          path: 'detail/:bundleId',
          name: 'phdCourseDetail',
          component: () =>
            import(
              /* webpackChunkName: "resource" */ '@/views/Resource/PHDCourse/PHDCourseDetail.vue'
            ),
          meta: {
            routerName: 'phdCourseDetail',
            showBack: true,
          },
        },
      ],
    },
    {
      path: 'assessmentFrame',
      name: 'assessmentFrame',
      component: () =>
        import(
          /* webpackChunkName: "resource" */ '@/views/Resource/AssessmentFrame/AssessmentFrame.vue'
        ),
      meta: {
        routerName: 'assessmentFrame',
        rootPage: true,
        noChild: true,
        menu: true,
      },
      children: [
        {
          path: 'addAssessmentSheet/:gradeFrameId/:schoolYear',
          name: 'addAssessmentSheet',
          component: () =>
            import(
              /* webpackChunkName: "resource" */ '@/views/Resource/AssessmentFrame/AddAssessmentSheet.vue'
            ),
          props: true,
          meta: {
            routerName: 'addAssessmentSheet',
            showBack: true,
          },
        },
        {
          path: 'editAssessmentSheet/:gradeTableId/:schoolYear',
          name: 'editAssessmentSheet',
          component: () =>
            import(
              /* webpackChunkName: "resource" */ '@/views/Resource/AssessmentFrame/EditAssessmentSheet.vue'
            ),
          props: true,
          meta: {
            routerName: 'editAssessmentSheet',
            showBack: true,
          },
        },
        {
          path: 'viewAssessmentSheet/:gradeTableId/:schoolYear',
          name: 'viewAssessmentSheet',
          component: () =>
            import(
              /* webpackChunkName: "resource" */ '@/views/Resource/AssessmentFrame/ViewAssessmentSheet.vue'
            ),
          props: true,
          meta: {
            routerName: 'viewAssessmentSheet',
            showBack: true,
          },
        },
      ],
    },
  ],
}

export const personal = {
  path: 'personal',
  name: 'personal',
  component: () => import(/* webpackChunkName: "personal" */ '@/views/Personal/Personal.vue'),
  hidden: true,
  meta: {
    routerName: 'personal',
    rootPage: true,
  },
}

export const book = {
  path: '/book/:bookId',
  name: 'book',
  component: () => import(/* webpackChunkName: "personal" */ '@/views/Book/Book.vue'),
  meta: {
    routerName: 'book',
    rootPage: true,
    auth: ['1401', '1402', '1403', '1404'],
  },
}

export const phdCourseBook = {
  path: '/phdCourseBook/:bookId',
  name: 'phdCourseBook',
  component: () => import(/* webpackChunkName: "phdCourse" */ '@/views/PHDCourse/CourseBook.vue'),
  meta: {
    routerName: 'phdCourseBook',
    rootPage: true,
    auth: ['1401', '1402', '1403', '1404'],
  },
}

export const flashCard = {
  path: '/flashCard/:bookId',
  name: 'flashCard',
  component: () => import(/* webpackChunkName: "phdCourse" */ '@/views/PHDCourse/FlashCard.vue'),
  meta: {
    routerName: 'flashCard',
    rootPage: true,
    auth: ['1401', '1402', '1403', '1404'],
  },
}

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/',
      redirect: { name: 'distributorMgmt' },
      name: 'main',
      component: Main,
      children: [
        {
          ...manage,
        },
        {
          ...resource,
        },
        {
          ...staffMgmt,
        },
        {
          ...personal,
        },
      ],
    },
    {
      ...book,
    },
    {
      ...phdCourseBook,
    },
    {
      ...flashCard,
    },
    {
      path: '/404',
      name: 'notFound',
      component: NotFound,
    },
    {
      path: '*',
      redirect: '/404',
    },
  ],
})

router.beforeEach((to, from, next) => {
  Store.commit('changeForceBack', false)
  if (to.name === 'login') {
    if (getToken()) {
      next({ name: 'manage' })
    } else {
      removeToken()
      next()
    }
  } else {
    if (getToken()) {
      next()
    } else {
      next({ name: 'login' })
    }
  }
})

export default router
